import React, { useCallback, useEffect, useState } from 'react'
import Tail from './Tail'
import Spear from './Spear'
import { getSetupCard, getSetupCardItemsPath} from '../../../hooks/useSelector';
import { useConfigPathContext } from '../../../providers/ConfigPathContextProvider';
import { useConfigStepsContext } from '../../../providers/ConfigStepsContextProvider';
import { isFolder, isMetaData, K_INFO, LoadCycle, useConfigsDataContext } from '../../../providers/ConfigsDataContextProvider';
import WizardFolderCtrl from '../dyson/WizardFolderCtrl';
import CreateSubFolder from '../dyson/CreateSubFolder';
import './SetupCard.css'

/*
  Setup Card 

  ---[ Applications ]-+--[   Releases  ]--+--[  Environments ]------+--[ Configs ]----------------------+
  path root           |  root.apps[a]     |   root.apps[a][rels][r] |   root.apps[a][rels][r][cfgs][c]  |
  |------------------------------------------------------------------------------------------------------  

*/
export default function SetupCard({stepName, pathChanged}) {
  const {configSteps, setConfigSteps}                   = useConfigStepsContext();
  const {setConfigPath}                                 = useConfigPathContext();
  const {getNode, loadCycle}                            = useConfigsDataContext();
  const [reloadFlag, setReloadFlag]                     = useState(false);
  const [subFoldersComp, setSubFoldersComp]             = useState('');
  const [showCreateFolder, setShowCreateFolder]         = useState(false);
  const [folderNameInProgress, setFolderNameInProgress] = useState(null);
  const [folderCreatedError, setFolderCreatedError]     = useState(null);



  const refreshMe = useCallback(() => setReloadFlag(prev => !prev), []);
  const myItemsPath = getSetupCardItemsPath(configSteps, stepName);

  //--- Effect ---  loadCycle FETCHED
  //
  useEffect(()=>{
    if (loadCycle === LoadCycle.Fetched) {      
      console.log('[SetupCard] INIT');
      refreshMe();
    }
  }, [loadCycle, refreshMe]);






  const addItem = useCallback(() => {
    setShowCreateFolder(true);
  }, []);


  // This is not like the Folders page, where there is only one parent folder for all showing sub-folders.
  // Here, we may have multiple cards open, so any card with items (i.e. sub-folders), is the parent for them, 
  // So, clicking to "rename" (or also delete for that matter), can not refer to the "current" getConfigCurNode() as the correct "parent" for this card's items.


  //------ Post Delete Item  ------
  // If the "delete" was on the last item in this card, the card will be empty, but still show.
  // Any delete, is like clicking again on the triggering path in the previous card's selected item.
  
  const myCard = getSetupCard(stepName);
  
  //------[    EFFECT Create SubFolders on Reload   ]------
  //
  useEffect(()=>{
    const myFolder = getNode(myItemsPath);  
    if (myFolder) {
      const createErrInfo = myFolder[K_INFO].folderCreatedErrorInfo;
      const inProgressFolderName = myFolder[K_INFO].folderNameInProgress;
      setFolderCreatedError(createErrInfo);
      setShowCreateFolder(Boolean(createErrInfo) || Boolean(inProgressFolderName));      
    
      const setupSubFolders = myFolder ? Object.keys(myFolder)
      .filter(nodeKey => !isMetaData(nodeKey))
      .filter(nodeKey => isFolder(myFolder[nodeKey]))
      .sort((l,r) => l.toLocaleLowerCase().localeCompare(r.toLocaleLowerCase()))
      .map(subFolderKey => {
          const renInfo = myFolder[subFolderKey][K_INFO].folderRenamedErrorInfo;
          const renErrInfo = renInfo ? {...renInfo} : null;
          return <WizardFolderCtrl parentFolderPath={myItemsPath} parentFolder={myFolder} folderName={subFolderKey} stepName={stepName} withError={renErrInfo} key={`${subFolderKey}_key`}/>  
      }) : '';
      
      console.log('[SetupCard %s] [%s items]', stepName, setupSubFolders?.length);
      setSubFoldersComp(setupSubFolders);
    }
    else {
      setSubFoldersComp('');
    }
  }, [reloadFlag, refreshMe, configSteps, setConfigPath, setConfigSteps, stepName, getNode, myCard, myItemsPath, pathChanged]);

  
  // -------  RENDER  --------
  

  return (
    <div className='setupCardWrap'>
      <Tail items={subFoldersComp.length} addItem={addItem}/>
      <div className='setupCard'>
        <div className='setupHeader'>
          {myCard.title}
        </div>
        <div className='setupItems'>
          {showCreateFolder && <CreateSubFolder parentFolderPath={myItemsPath} hideMe={() => setShowCreateFolder(false)} withError={folderCreatedError} folderNameInProgress={folderNameInProgress}/>}
          {subFoldersComp}
        </div>
      </div>
      <Spear />
    </div>
  )
}
